/**
 * Hook pour utiliser les permissions dans les composants
 * Version qui utilise le contexte Auth sans dépendance circulaire
 */

import { useContext } from 'react';
import { AuthContext } from '@/app/providers/AuthContext';

interface UsePermissionsHookReturn {
  // État
  permissionsLoading: boolean;
  
  // Vérifications de permissions (rôles)
  isAdminForOrganization: (organizationId: string) => boolean;
  hasAccessToOrganization: (organizationId: string) => boolean;
  getUserRole: (organizationId: string) => string | null;
  
  // Vérifications de permissions granulaires
  canViewOrders: (organizationId: string) => boolean;
  canManageOrders: (organizationId: string) => boolean;
  canManageConfiguration: (organizationId: string) => boolean;
  canViewAnalytics: (organizationId: string) => boolean;
  canManageUsers: (organizationId: string) => boolean;
  
  // Actions
  refreshPermissions: () => Promise<void>;
}

export const usePermissionsHook = (): UsePermissionsHookReturn => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('usePermissionsHook must be used within an AuthProvider');
  }
  
  const {
    permissionsLoading,
    isAdminForOrganization,
    hasAccessToOrganization,
    getUserRole,
    canViewOrders,
    canManageOrders,
    canManageConfiguration,
    canViewAnalytics,
    canManageUsers,
    refreshPermissions
  } = context;
  
  return {
    permissionsLoading,
    isAdminForOrganization,
    hasAccessToOrganization,
    getUserRole,
    canViewOrders,
    canManageOrders,
    canManageConfiguration,
    canViewAnalytics,
    canManageUsers,
    refreshPermissions
  };
};

